import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

import { recordNoteJson } from '../models/dto';

@Pipe({
  name: 'filterData',
})
export class FilterDataRecordPipe implements PipeTransform {
  formatDate = 'YYYYMMDDHHmmss';
  formatJPDate = 'YYYY年MM月DD日HHmmss';

  transform(items: recordNoteJson[], args: any, searchBox: boolean = false, objbelong: string[] = []): any {
    if (items && items.some((item) => item.ownunitcd) && objbelong && objbelong.length > 0)
      items = items.filter((item: recordNoteJson) => this.checkObjbelongAndOwnunitcd(objbelong, item.ownunitcd));

    const filter = args.searchKey.toString();
    const pickupflg = Number(args.pickupflg);
    if (pickupflg != 0) items = items.filter((item: any) => Number(item.pickupflg) === pickupflg);
    if ((filter == undefined && filter.length == null) || filter.length === 0 || items.length === 0 || !searchBox) {
      return items;
    }
    return items.filter(
      (item: any) =>
        this.mapFilterOption(item.objnm, filter) ||
        this.mapFilterOption(moment(item.sdate, this.formatDate).format(this.formatJPDate), filter) ||
        this.mapFilterOption(item.ttlnm, filter) ||
        this.mapFilterOption(this.getResultAtr(item.resultatr), filter) ||
        item.itmarray?.some(
          (itm: any) =>
            this.mapFilterOption(itm.label, filter) ||
            this.mapFilterOption(itm.text, filter) ||
            this.mapFilterOption(itm.unit, filter),
        ),
    );
  }

  transformViewRecord(items: recordNoteJson[], args: any, searchBox: boolean = false): any {
    const filter = args.searchKey.toString();
    const pickupflg = Number(args.pickupflg);
    if (pickupflg != 0) items = items.filter((item: any) => Number(item.pickupflg) === pickupflg);
    if ((filter == undefined && filter.length == null) || filter.length === 0 || items.length === 0 || !searchBox) {
      return items;
    }
    return items.filter(
      (item: any) =>
        this.mapFilterOption(item.objnm, filter) ||
        this.mapFilterOption(moment(item.sdate, this.formatDate).format(this.formatJPDate), filter) ||
        this.mapFilterOption(item.ttlnm, filter) ||
        this.mapFilterOption(item.resultatr, filter) ||
        item.itmarray?.some(
          (itm: any) =>
            this.mapFilterOption(itm.label, filter) ||
            this.mapFilterOption(itm.text, filter) ||
            this.mapFilterOption(itm.unit, filter),
        ) ||
        this.mapFilterOption(item.officeNm, filter) ||
        this.mapFilterOption(item.v2contents, filter) ||
        item.field?.some(
          (itm: any) => this.mapFilterOption(itm.label, filter) || this.mapFilterOption(itm.content, filter),
        ),
    );
  }

  checkObjbelongAndOwnunitcd(objbelongs: string[], ownunitcd: string): boolean {
    if (!ownunitcd) return true;
    const arrOwnunitcd = this.splitObj(ownunitcd);
    const indexCorpcd = 0,
      indexOfficecd = 1,
      indexBlockcd = 2,
      indexSubcd = 3,
      indexUnitcd = 4;
    for (const objbelong of objbelongs) {
      const arrObjbelong = this.splitObj(objbelong);
      if (
        arrObjbelong[indexCorpcd] === arrOwnunitcd[indexCorpcd] &&
        arrObjbelong[indexOfficecd] === arrOwnunitcd[indexOfficecd]
      )
        if (arrObjbelong[indexBlockcd] === '00') return true;
        else if (arrObjbelong[indexBlockcd] === arrOwnunitcd[indexBlockcd])
          if (arrObjbelong[indexSubcd] === arrOwnunitcd[indexSubcd])
            if (arrObjbelong[indexUnitcd] === '000') return true;
            else if (arrObjbelong[indexUnitcd] === arrOwnunitcd[indexUnitcd]) return true;
    }

    return false;
  }

  splitObj(obj: string, pattern: number[] = [1, 2, 2, 2, 3]): string[] {
    const result: string[] = [];
    let index = 0;

    for (const len of pattern) {
      result.push(obj.substr(index, len));
      index += len;
    }

    return result;
  }

  mapFilterOption(filterData: string, searchKey: string) {
    return filterData?.toLowerCase().includes(searchKey?.toLowerCase());
  }

  getResultAtr(resultAtr: number) {
    switch (resultAtr) {
      case 2:
        return '実施';
      case 3:
        return '中止';
      default:
        return '';
    }
  }
}
